<template>
  <!-- The signed-out door (design 139, direction A): the stacked mark over the
       page's one card, the other language as one word under it — and nothing
       in the corners. The theme follows the device (stores/theme.ts) and the
       language the browser (lib/locale.ts), so neither needs a control here.
       No self-serve signup by design: users are invited, organizations are born
       in the admin panel. -->
  <div class="min-h-screen flex flex-col items-center bg-background text-foreground font-sans antialiased px-4 pt-[9vh] pb-12">
    <router-link to="/login" class="mb-7 rounded-md focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring">
      <BrandMark stacked ground="page" :size="60" />
    </router-link>

    <main class="w-full flex flex-col items-center">
      <router-view />
    </main>

    <LanguageLink class="mt-6" />
  </div>
</template>

<script setup lang="ts">
import BrandMark from '@/components/layout/BrandMark.vue'
import LanguageLink from '@/components/layout/LanguageLink.vue'
</script>
